import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  header: {
    id: 'views.AuthoritiesView.header',
    defaultMessage: 'Władze'
  },
  management: {
    id: 'views.AuthoritiesView.management',
    defaultMessage: 'Zarząd'
  },
  boardOfDirectors: {
    id: 'views.AuthoritiesView.boardOfDirectors',
    defaultMessage: 'Rada nadzorcza'
  },
  statement: {
    id: 'views.AuthoritiesView.statement',
    defaultMessage: 'ŻYCIORYS I OŚWIADCZENIA'
  }
});



// WEBPACK FOOTER //
// ./src/views/Authorities/AuthoritiesView.intl.js